import * as React from "react";
import { useRouter } from "next/router";

export function ClientSideOnly({ children }: React.PropsWithChildren<unknown>) {
  const [isReady, setIsReady] = React.useState(false);
  const router = useRouter();
  React.useEffect(() => {
    setIsReady(true);
  }, [router.isReady]);

  // eslint-disable-next-line unicorn/no-null
  return isReady ? <>{children}</> : null;
}
